import { accessRole } from "../../../../helpers/access_role";

import React, { Fragment } from "react";
import apiResponse from "../../../../services/apiResponse";
import classnames from "classnames";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Button,
  Spinner,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import moment from "moment";
import { Link, Redirect } from "react-router-dom";

import Select from "../../../../helpers/ui/CustomSelect";
import DetailBloc from "./Blocs/DetailBloc";
import TableComponent from "./Components/TableComponent";
import TableComponentNew from "./Components/TableComponentNew";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";

class DetailView extends React.Component {
  constructor(props) {
    super(props);

    this.detailBloc = new DetailBloc();
    this.activeRef = React.createRef();

    this.state = {
      selectedOption: [],
      activeTab: sessionStorage.getItem("indePositionMappingActiveTab")
        ? sessionStorage.getItem("indePositionMappingActiveTab")
        : "1",
      filter: {
        work_unit_uuid: "",
        year: "",
        month: "",
      },
      workUnit: "",
      optionUnits: [],
      modal: false,
      fileUrl: "",
      modalImport: false,
      file: null,
      fileTemplate: "",
      downloadingFile: false,
      loading: false,
      failed: false,
      loadingFirst: false,
      success: false,
      dataReady: false,
    };
  }

  componentDidMount() {
    console.log(this.props)
    // this.detailBloc.fetchcheckmutasipegawaiChannel.subscribe((result) => {
    //   switch (result.status) {
    //     case apiResponse.LOADING:
    //       this.setState({
    //         loadingFirst: true,
    //         dataReady: false, 
    //       });
    //       break;
    //     case apiResponse.COMPLETED:
    //       this.setState(
    //         {
    //           loadingFirst: false,
    //           dataReady: true, 
    //         },
    //         () => {
    //           this.loadOtherData();
    //         }
    //       );
    //       break;
    //     case apiResponse.ERROR:
    //       this.setState({
    //         loadingFirst: false,
    //         dataReady: true,
    //       });
    //       this.loadOtherData();
    //       break;
    //     default:
    //       break;
    //   }
    // });

    // this.detailBloc.fetchcheckmutasipegawai({ periode: this.props.uuid });
    this.loadOtherData();
    this.detailBloc.fetchimportDataPetaJabatanChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
            modalImport: false,
          });
          this.reloadActiveRef();
          //this.reloadAllData();
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            modalImport: false,
          });
          break;
        default:
          break;
      }
    });
  }

  loadOtherData = () => {
    this.detailBloc.workUnitChannel?.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({ optionUnits: result.data.response.result });
          break;
        default:
          break;
      }
    });

    this.detailBloc.fetchWorkUnit();

    //this.reloadActiveRef();
  };

  reloadAllData = () => {
    this.setState({
      loadingFirst: true,
      dataReady: false,
    });

    this.detailBloc.fetchcheckmutasipegawai({ periode: this.props.uuid });
  };

  componentWillUnmount() {
    this.detailBloc.workUnitChannel?.unsubscribe();
    this.detailBloc.fetchcheckmutasipegawaiChannel?.unsubscribe();
    this.detailBloc.fetchimportDataPetaJabatanChannel?.unsubscribe();
  }

  toggleImport = () => {
    this.setState({ modalImport: !this.state.modalImport });
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
      sessionStorage.setItem("indePositionMappingActiveTab", tab);
    }
  };

  reloadActiveRef = () => {
    if (this.activeRef.current) {
      this.activeRef.current.setTokenAPI();
    }
  };

  handleButtonExport = () => {
    this.setState({ fileUrl: "", modal: true });

    this.detailBloc.exportExcelChannel.subscribe((result) => {
      if (result.status === apiResponse.COMPLETED && result.data.status) {
        let response = result.data.response;
        this.setState({ fileUrl: response.file_url });
      }
    });

    this.detailBloc.fetchExportExcel({
      uuid: this.props.uuid,
    });
  };

  handleButtonExportNew = () => {
    this.setState({ fileUrl: "", modal: true });

    this.detailBloc.exportNewChannel.subscribe((result) => {
      if (result.status === apiResponse.COMPLETED && result.data.status) {
        let response = result.data.response;
        this.setState({ fileUrl: response.file_url });
      }
    });

    this.detailBloc.fetchExportNew({
      uuid: this.props.uuid,
      work_unit: this.state.workUnit,
    });
  };

  handleButtonExportTemplate = () => {
    this.setState({ downloadingFile: true });

    this.detailBloc.fetchexportTemplatePetaJabatanChannel.subscribe(
      (result) => {
        switch (result.status) {
          case apiResponse.COMPLETED:
            if (result.data.status) {
              let response = result.data.response;
              if (response.file_url) {
                const link = document.createElement("a");
                link.href = response.file_url;
                link.download = response.file_url.split("/").pop();
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }
            this.setState({ downloadingFile: false });
            break;
          case apiResponse.ERROR:
            this.setState({ downloadingFile: false });
            break;
          default:
            break;
        }
      }
    );

    this.detailBloc.fetchexportTemplatePetaJabatan();
  };

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, "file_upload");
    await this.detailBloc.fetchimportDataPetaJabatan(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  LoadingState = () => (
    <Container fluid>
      <Card>
        <CardBody>
          <div
            style={{
              padding: "120px 0",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Spinner
              color="primary"
              style={{ width: "4rem", height: "4rem" }}
            />
            <h5 className="mt-4 text-muted">
              Memuat data...
            </h5>
          </div>
        </CardBody>
      </Card>
    </Container>
  );

  render() {
    const {
      activeTab,
      optionUnits,
      workUnit,
      filter,
      modalImport,
      downloadingFile,
      modal,
      fileUrl,
      loadingFirst,
      dataReady,
    } = this.state;

    // if (loadingFirst || !dataReady) {
    //   return this.LoadingState();
    // }

      return (
        <Fragment>
          <Container fluid>
            <Card>
              <CardBody>
                <div className="float-end">
                  <Link to={`/kepegawaian/petajabatan.html`}>
                    <Button outline color="primary">
                      <i className="uil uil-backward"></i> Kembali
                    </Button>
                  </Link>
                </div>

                <CardTitle>Peta Jabatan</CardTitle>
                <hr />

                {/* FILTER */}
                <Row className="mb-3">
                  <label className="col-md-2 col-form-label">Unit Kerja</label>
                  <Col md="6">
                    <Select
                      isAvForm={false}
                      required="required"
                      options={this.state.optionUnits}
                      optionValue="work_unit_uuid"
                      optionLabel="work_unit_name_tabs"
                      classNamePrefix="select2-unit"
                      isClearable={true}
                      value={
                        this.state.optionUnits?.find(
                          (x) => x.work_unit_uuid === workUnit
                        ) || null
                      }
                      onChange={(opt) =>
                        this.setState({
                          workUnit: opt ? opt.work_unit_uuid : null,
                        })
                      }
                    />
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col md="2"></Col>
                  <Col md="10">
                    <Button
                      color="primary"
                      type="button"
                      onClick={() =>
                        this.setState({
                          filter: { work_unit_uuid: workUnit },
                        })
                      }
                    >
                      <i className="uil-search-alt"></i> Cari
                    </Button>{" "}
                    <Button
                      color="warning"
                      type="button"
                      onClick={() =>
                        this.setState({ workUnit: null, filter: {} })
                      }
                    >
                      <i className="uil-refresh"></i> Reset
                    </Button>{" "}
                    {activeTab === "1" ? (
                      <>
                        <Button
                          color="success"
                          type="button"
                          onClick={this.handleButtonExport}
                        >
                          <i className="uil-file-download-alt"></i> Export Detail
                        </Button>{" "}
                        <Button
                          color="success"
                          type="button"
                          onClick={this.handleButtonRekapExport}
                        >
                          <i className="uil-file-download-alt"></i> Export Rekap
                        </Button>
                      </>
                    ) : (
                      <Button
                        color="success"
                        type="button"
                        onClick={this.handleButtonExportNew}
                      >
                        <i className="uil-file-download-alt"></i> Export New
                      </Button>
                    )}
                  </Col>
                </Row>

                <hr />

                {/* TAB */}
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "1",
                      })}
                      onClick={() => this.toggle("1")}
                    >
                      <span className="d-none d-sm-block">Peta Jabatan</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: activeTab === "2",
                      })}
                      onClick={() => this.toggle("2")}
                    >
                      <span className="d-none d-sm-block">
                        Peta Jabatan (New)
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>

                {/* CONTENT */}
                <TabContent activeTab={activeTab} className="p-3 text-muted">
                    <TabPane tabId="1">
                      <hr />
                      <TableComponent
                        ref={this.activeRef}
                        handleInactiveSuccess={this.reloadActiveRef}
                        uuid={this.props.uuid}
                        filter={filter}
                      />
                    </TabPane>

                    <TabPane tabId="2">
                      <Button
                        color="primary"
                        onClick={() => this.setState({ modalImport: true })}
                      >
                        Import data
                      </Button>
                      <hr />
                      <TableComponentNew
                        ref={this.activeRef}
                        handleInactiveSuccess={this.reloadActiveRef}
                        uuid={this.props.uuid}
                        filter={filter}
                        periode={this.props.periode}
                      />
                    </TabPane>
                  </TabContent>
                {/* {dataReady && (
                  <TabContent activeTab={activeTab} className="p-3 text-muted">
                    <TabPane tabId="1">
                      <hr />
                      <TableComponent
                        ref={this.activeRef}
                        handleInactiveSuccess={this.reloadActiveRef}
                        uuid={this.props.uuid}
                        filter={filter}
                      />
                    </TabPane>

                    <TabPane tabId="2">
                      <Button
                        color="primary"
                        onClick={() => this.setState({ modalImport: true })}
                      >
                        Import data
                      </Button>
                      <hr />
                      <TableComponentNew
                        ref={this.activeRef}
                        handleInactiveSuccess={this.reloadActiveRef}
                        uuid={this.props.uuid}
                        filter={filter}
                      />
                    </TabPane>
                  </TabContent>
                )} */}
              </CardBody>
            </Card>
          </Container>

          {/* MODAL IMPORT */}
          <Modal
            isOpen={modalImport}
            toggle={() => this.setState({ modalImport: !modalImport })}
          >
            <ModalHeader
              toggle={() => this.setState({ modalImport: !modalImport })}
            >
              Import Data Peta Jabatan
            </ModalHeader>

            <ModalBody>
              <div className="mb-3">
                {downloadingFile ? (
                  <>
                    <Spinner size="sm" /> Mengunduh...
                  </>
                ) : (
                  <a
                    href="javascript:void(0)"
                    onClick={this.handleButtonExportTemplate}
                  >
                    Unduh format upload
                  </a>
                )}
              </div>

              <AvForm
                className="needs-validation"
                onValidSubmit={(e, values) =>
                  this.handlerOnSubmit(e, values)
                }
              >
                <FileInput
                  name="file_upload"
                  validate={{ required: { value: true } }}
                  col="6"
                  isMultiple={false}
                  maxFiles={1}
                  errorMessage="Harap pilih file"
                />

                <AvField
                  type="hidden"
                  name="periode"
                  defaultValue={this.props.uuid}
                />

                <ModalFooter className="px-0">
                  <Button
                    color="secondary"
                    onClick={() => this.setState({ modalImport: false })}
                  >
                    Batal
                  </Button>
                  <Button color="primary">Import</Button>
                </ModalFooter>
              </AvForm>
            </ModalBody>
          </Modal>

          {/* MODAL EXPORT */}
          <Modal
            isOpen={modal}
            centered
            toggle={() => this.setState({ modal: !modal })}
          >
            <ModalHeader
              toggle={() => this.setState({ modal: false, fileUrl: "" })}
            >
              Export
            </ModalHeader>

            <ModalBody>
              {fileUrl === "" ? (
                <div className="text-center">
                  <Spinner className="m-1" color="primary" />
                  <div>Memproses Data</div>
                </div>
              ) : (
                <>
                  <Row className="mb-3">
                    <label className="col-md-4">Jenis File</label>
                    <Col md="8">Excel (xlsx)</Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Waktu Generate</label>
                    <Col md="8">
                      {moment(new Date()).format("DD/MM/YYYY HH:mm")}
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <label className="col-md-4">Link</label>
                    <Col md="8">
                      <a
                        href={fileUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-success"
                      >
                        Download <i className="fa fa-download ms-1"></i>
                      </a>
                    </Col>
                  </Row>
                </>
              )}
            </ModalBody>

            <ModalFooter>
              <Button
                type="button"
                color="secondary"
                onClick={() => this.setState({ modal: false, fileUrl: "" })}
              >
                Kembali
              </Button>
            </ModalFooter>
          </Modal>

          <ConfirmAlert
            confirmTitle="Konfirmasi!"
            confirmInfo="Apakah anda yakin akan menyimpan data ini?"
            loadingTitle="Mengirim data..."
            loadingInfo="Tunggu beberapa saat"
            successTitle="Berhasil!"
            successInfo="Data berhasil disimpan"
            failedTitle="Gagal!"
            failedInfo="Data gagal disimpan"
            showConfirm={this.state.confirm}
            showLoading={this.state.loading}
            showSuccess={this.state.success}
            showFailed={this.state.failed}
            response={this.confirmResponse}
          />

          {this.state.redirect && (
            <Redirect
              to={
                "/kepegawaian/petajabatan.html?detail&uuid=" +
                this.props.uuid
              }
            />
          )}
        </Fragment>
      );
    
  }
}

export default DetailView;